import { clientbookApi } from '../core/clientbook-api';
import axios from 'axios';

/**
 * Generate a presigned S3 URL for uploading an attachment.
 * @param {Object} options
 * @param {string} options.fileType - MIME type of the file (e.g. 'image/png')
 * @param {string} [options.attachmentType='mass_message'] - Type of attachment
 */
export const generatePresignedUrl = async ({ fileType, attachmentType = 'message' }) => {
  return clientbookApi.post({
    url: '/uploads/presignedurls',
    data: { fileType, attachmentType },
    loading: false,
  });
};

/**
 * Upload a file directly to S3 using a presigned URL.
 * @param {Object} options
 * @param {string} options.presignedUrl - The presigned S3 URL
 * @param {File} options.file - The file to upload
 */
export const uploadToS3 = async ({ presignedUrl, file }) => {
  return axios.put(presignedUrl, file, {
    headers: { 'Content-Type': file.type, Authorization: null },
  });
};
